import { render } from "./PlayView.vue?vue&type=template&id=7ec9e880&scoped=true"
import script from "./PlayView.vue?vue&type=script&lang=ts"
export * from "./PlayView.vue?vue&type=script&lang=ts"

import "./PlayView.vue?vue&type=style&index=0&id=7ec9e880&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ec9e880"

export default script